import copy from 'copy-to-clipboard';
import { partialRight } from 'es-toolkit/compat';

export const parseInteger: (target: string) => number = partialRight(parseInt, 10);
export const handleFloat = (value: number) => parseFloat(value.toFixed(10));

export type TimeOfDay = 'morning' | 'afternoon' | 'evening';

export const browserTimeOfDay: () => TimeOfDay = () => {
  const date = new Date();
  const hour = date.getHours();

  if (hour < 12 && hour >= 5) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  return 'evening';
};

export const copyToClipboard = (element: HTMLInputElement) => {
  if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
    copy(element.value);
  } else {
    copy(element.textContent ?? '');
  }
};

export function getBackgroundByUserTimeOfDay() {
  const userTimeOfDay = browserTimeOfDay();

  const backgroundForTimeOfDay = {
    morning: 'bmtGold10',
    afternoon: 'bmtBlue10',
    evening: 'bmtNavy60',
  };

  return backgroundForTimeOfDay[userTimeOfDay];
}
